import { z } from 'zod';
export const AssignmentsParameterSchema = z.enum(['ASSIGNMENTS_BASE_URL']);
export const AssignmentsParameterEnum = AssignmentsParameterSchema.enum;
